import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RoleService } from '../../../../core/services/role.service';
import { LoaderService } from '../../../../core/shared/services/loader.service';
import { BaseComponent } from '../../../../core/shared/base.component';

@Component({
  selector: 'app-roles-management',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './roles-management.component.html',
  styleUrls: ['./roles-management.component.scss']
})
export class RolesManagementComponent extends BaseComponent implements OnInit {
  roles: any[] = [];
  loading = false;
  selectedRole: any = null;
  isNewRole = false;

  private roleService = inject(RoleService);
  private loader = inject(LoaderService);

  constructor() {
    super();
  }

  ngOnInit() {
    this.loadRoles();
  }

  loadRoles() {
    this.loading = true;
    this.loader.show();

    this.roleService.getAllRoles().subscribe({
      next: (response: any) => {
        this.roles = response.data;
        this.loading = false;
        this.loader.hide();
      },
      error: (error) => {
        console.error('Error cargando roles:', error);
        this.loading = false;
        this.loader.hide();
      }
    });
  }

  editRole(role: any) {
    this.selectedRole = { ...role };
    this.isNewRole = false;
  }

  createNewRole() {
    this.selectedRole = { name: '', description: '', permissions: [] };
    this.isNewRole = true;
  }

  saveRole() {
    this.loading = true;
    this.loader.show();

    const saveObservable = this.isNewRole
      ? this.roleService.createRole(this.selectedRole)
      : this.roleService.updateRole(this.selectedRole.id, this.selectedRole);

    saveObservable.subscribe({
      next: () => {
        this.loadRoles();
        this.selectedRole = null;
        this.isNewRole = false;
        this.loader.hide();
      },
      error: (error) => {
        console.error('Error guardando rol:', error);
        this.loading = false;
        this.loader.hide();
      }
    });
  }

  deleteRole(role: any) {

    this.confirm(`¿Está seguro de que desea eliminar el rol: <strong>${role.name}</strong>?`, "Eliminar Rol", "Si, eliminar")
      .then(res => {
        if (res.isConfirmed) {
          this.loading = true;
          this.loader.show();

          this.roleService.deleteRole(role.id).subscribe({
            next: () => {
              this.loadRoles();
              this.loading = false;
              this.loader.hide();
            },
            error: (error) => {
              console.error('Error eliminando rol:', error);
              this.loading = false;
              this.loader.hide();
            }
          });
        }
      });

  }

  cancelEdit() {
    this.selectedRole = null;
    this.isNewRole = false;
  }
} 